import { render, staticRenderFns } from "./APlataformas.vue?vue&type=template&id=7baac5bc"
import script from "./APlataformas.vue?vue&type=script&lang=js"
export * from "./APlataformas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports